import { render } from "./Pager.vue?vue&type=template&id=3dd4128e&scoped=true&ts=true"
import script from "./Pager.vue?vue&type=script&lang=ts"
export * from "./Pager.vue?vue&type=script&lang=ts"

import "./Pager.vue?vue&type=style&index=0&id=3dd4128e&lang=scss&scoped=true"

import exportComponent from "/root/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dd4128e"]])

export default __exports__